import { render, staticRenderFns } from "./DeviceOsDetails.vue?vue&type=template&id=7f267414&scoped=true&"
import script from "./DeviceOsDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceOsDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeviceOsDetails.vue?vue&type=style&index=0&id=7f267414&prod&lang=scss&"
import style1 from "./DeviceOsDetails.vue?vue&type=style&index=1&id=7f267414&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f267414",
  null
  
)

export default component.exports